var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("label", { attrs: { for: "c" } }, [_vm._v("Campanha:")]),
      _vm._v(" "),
      _c("b-form-input", {
        attrs: { id: "c", placeholder: "Código da Campanha" },
        model: {
          value: _vm.codigo,
          callback: function($$v) {
            _vm.codigo = $$v
          },
          expression: "codigo"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1145f8e7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1145f8e7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/getCampanha.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1145f8e7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/getCampanha.vue
// module chunks = 2